import { useEffect, useState } from 'react';

async function getIsLeadExcessArea(categoryId: number, postcode: string) {
  const response = await fetch(
    `/api/lead-excess-area?category=${categoryId}&postcode=${postcode}`,
  );
  if (!response.ok) {
    throw new Error('Failed to fetch lead excess area');
  }

  return response.json();
}

export function useIsLeadExcessArea(categoryId?: number, postcode?: string) {
  const [isLeadExcessArea, setIsLeadExcessArea] = useState<boolean | null>(
    null,
  );

  useEffect(() => {
    if (categoryId && postcode) {
      getIsLeadExcessArea(categoryId, postcode)
        .then(data => setIsLeadExcessArea(data.data))
        .catch(() => setIsLeadExcessArea(false));
    }
  }, [categoryId, postcode]);

  return isLeadExcessArea;
}
